/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { environment } from "config/runtimeConfig";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import { AuthProvider } from "context/AuthProvider";
import UserLayout from "layouts/User";
import AvisoLegal from "layouts/AvisoLegal";
import Normativa from "layouts/Normativa";
import TerminosYCondiciones from "layouts/TerminosYCondiciones";
import ProteccionDeDatos from "layouts/ProteccionDeDatos";
import AppAlerts from "components/common/AppAlerts";
import LoginEmpresa from "views/auth/LoginEmpresa";
import Login from "views/auth/Login";

const root = ReactDOM.createRoot(document.getElementById("root"));
const ENVIRONMENT = `${environment}`;
const estiloFlotante = {
  position: 'fixed',  // 'fixed' para que siempre esté en la pantalla
  top: '20px',        // Ajusta la posición vertical
  left: '20px',       // Ajusta la posición horizontal
  backgroundColor: 'rgba(0, 0, 0, 0.7)',  // Fondo semi-transparente
  color: 'white',
  padding: '10px',
  borderRadius: '5px',
  pointerEvents: 'none',  // No interfiera con otros elementos
  zIndex: 9999           // Asegura que esté por encima de todo
};

const hostname = window.location.hostname;


  if(hostname.split(".")[0] === "empresa"){

    root.render(
      <>
      {ENVIRONMENT!=="PROD"?<span style={estiloFlotante}>{ENVIRONMENT}</span>:""}
   <BrowserRouter>
    <AuthProvider>
      <AppAlerts />
      <Routes>
        <Route path="/" element={<LoginEmpresa />} />
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="/aviso-legal" element={<AvisoLegal/>}/>
        <Route path="/normativa" element={<Normativa/>}/>
        <Route path="/terminos-condiciones" element={<TerminosYCondiciones/>}/>
        <Route path="/proteccion-datos" element={<ProteccionDeDatos/>}/>
      </Routes>
    </AuthProvider>
  </BrowserRouter>
  </>
    );
  }else{
    
    root.render(
      <>
      {ENVIRONMENT!=="PROD"?<span style={estiloFlotante}>{ENVIRONMENT}</span>:""}
      <BrowserRouter>
    <AuthProvider>
      <AppAlerts />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/user/*" element={<UserLayout />} />
        <Route path="/aviso-legal" element={<AvisoLegal/>}/>
        <Route path="/normativa" element={<Normativa/>}/>
        <Route path="/terminos-condiciones" element={<TerminosYCondiciones/>}/>
        <Route path="/proteccion-datos" element={<ProteccionDeDatos/>}/>
        <Route path="*" element={<Navigate to={`/`} replace />} />
      </Routes>
    </AuthProvider>
  </BrowserRouter>
  </>
    );
 
}
